
import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from '../seguranca/auth.service';
import { ErrorHandlerService } from './error-handler.service';
import { AvisoService } from './services/aviso.service';
import { ContextoDeProjetoService } from './services/contexto-de-projeto.service';
import { ExportacaoXlsService } from './services/exportacao/exportacao-xls.service';
import { MensageriaService } from './services/mensageria/mensageria.service';
import { ModuloNaoDisponivelComponent } from './not-found/modulo-nao-disponivel.component';
import { EixoProgramaHasProponenteCredenciadoService } from './services/eixo-programa-has-proponente-credenciado/eixo-programa-has-proponente-credenciado.service';
import { EntidadeConcedenteHasUsuarioService } from './services/entidade-concedente-has-usuario/entidadeConcedenteHasUsuario.service';
import { EntidadeProponenteHasUsuarioService } from './services/entidade-proponente-has-usuario/entidadeProponenteHasUsuario.service';
import { HabilitacaoService } from './services/habilitacao/habilitacao.service';
import { RequisitoProponenteService } from './services/edital-credenciamento/RequisitoProponente.service';

import { SharedsModule } from '../shareds/shareds.module';

@NgModule({
  imports: [
    SharedsModule,
    CommonModule,
    HttpModule,
    RouterModule,
  ],
  declarations: [
    ModuloNaoDisponivelComponent,
  ],
  exports: [
    ModuloNaoDisponivelComponent,
  ],
  providers: [
    Title,
    AuthService,
    JwtHelper,
    { provide: LOCALE_ID, useValue: 'pt-BR' },

    //Nao possuem module
    ConfirmationService,
    // Exportacao em planilha (ADR-0022 §3.7): fica aqui porque e usada por telas
    // de modulos diferentes — financeiro, conciliacao e carga massiva.
    ExportacaoXlsService,
    // Mensageria (ADR-0029): fica aqui porque o CONTADOR do cabecalho a usa, e o
    // cabecalho e do core — nao do modulo lazy da tela de mensagens.
    MensageriaService,
    EntidadeConcedenteHasUsuarioService,
    EntidadeProponenteHasUsuarioService,
    // O aviso na tela e a regra de que ele nao se repete (ADR-0078 §3.1). Vem ANTES do
    // tratador de erro e do contexto de projeto: os dois dependem dele.
    AvisoService,
    ErrorHandlerService,
    // Qual projeto esta aberto (ADR-0072 §3.2): fica aqui porque seis telas de dois
    // modulos lazy diferentes o consultam, e tem de ser a MESMA instancia.
    ContextoDeProjetoService,
    RequisitoProponenteService,
    EixoProgramaHasProponenteCredenciadoService,
    HabilitacaoService,
  ]
})
export class CoreModule {}
